import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip
} from "reactstrap";

import Breadcrumbs from "components/Common/BreadcrumbTitle";
import AppConstant from "../../constants/app.constants";

import TableContainerV1 from "components/Common/TableContainerV1";

import { getPermission } from "../../helpers/UAM/permission.helper";

const TableActionsComponent = (rowData) => {
  const navigate = useNavigate();
  const { roleName } = JSON.parse(localStorage.getItem("user"))

  const navigateToeEditPermission = (id) => {
    const encryptedId = btoa(id.toString());
    navigate(`/${roleName}/permission/edit?id=${encodeURIComponent(encryptedId)}`)
  };
  const navigateToeViewPermission = (id) => {
    const encryptedId = btoa(id.toString());
    navigate(`/${roleName}/permission/view?id=${encodeURIComponent(encryptedId)}`)
  };


  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem
          onClick={() => {
            navigateToeViewPermission(rowData.id)
          }}
        >
          <i
            className="mdi mdi-eye font-size-16 text-success me-1"
            id="viewtooltip"
          ></i>
          View
          <UncontrolledTooltip placement="top" target="viewtooltip">
            View
          </UncontrolledTooltip>
        </DropdownItem>
        <DropdownItem
          onClick={() => {
            navigateToeEditPermission(rowData.id);
          }
          }
        >
          <i className="mdi mdi-pencil font-size-16 text-success me-1" id="edittooltip"></i>
          Edit
          <UncontrolledTooltip placement="top" target="edittooltip">
            Edit
          </UncontrolledTooltip>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

const Permission = props => {

  //meta title
  document.title = "Permission | DMS";
  const { roleName } = JSON.parse(localStorage.getItem("user"))
  const navigate = useNavigate();
  const [permissionList, setPermissionList] = useState([]);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageCount: 0, totalRecords: 0 });
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [sortingOptions, setSortingOptions] = useState({ column: 'id', isAsc: false, optionalColumn: ['Action', 'allPermissions'] });

  // Customber Column
  const columns = useMemo(
    () => [
      {
        Header: 'Id',
        accessor: 'id',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value;
          ;
        }
      },
      {
        Header: 'Permission Name',
        accessor: 'permissionDisplayName',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value;
        }
      },
      {
        Header: 'Permission Description',
        accessor: 'permissionDescription',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value;
        }
      },
      {
        Header: 'Assign Permissions',
        accessor: 'allPermissions',
        filterable: true,
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          let listPermission = []
          if (rowData.isCreate) {
            listPermission.push("Create")
          }
          if (rowData.isView) {
            listPermission.push("View")
          }
          if (rowData.isList) {
            listPermission.push("List")
          }
          if (rowData.isUpload) {
            listPermission.push("Upload")
          }
          if (rowData.isEdit) {
            listPermission.push("Edit")
          }
          if (rowData.isDelete) {
            listPermission.push("Delete")
          }
          if (rowData.isApprove) {
            listPermission.push("Approve")
          }
          if (rowData.isReject) {
            listPermission.push("Reject")
          }
          if (rowData.isFullAccess) {
            listPermission.push("Fullaccess")
          }
          return listPermission.join(", ")
        }

      },
      {
        Header: 'Action',
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponent(rowData)
        }
      },
    ],
    []
  );


  useEffect(() => {
    getPermission({ page: 1, limit: AppConstant.TABLE_RECORD_SIZE })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setPermissionList(responseFromAPI.data.data)
          const { totalItems, totalPages, currentPage } = responseFromAPI.data
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        }
      })
      .catch(error => { })
  }, []);

  const handlePageChange = (page, pageSize, searchKey = searchValue, columnName = columnId, sortingOrder = sortingOrderStatus) => {
    setPageSize(pageSize);
    getPermission({ page, limit: pageSize, searchKey, columnName, sortingOrder })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setPermissionList(responseFromAPI.data.data)
          const { totalItems, totalPages, currentPage } = responseFromAPI.data
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        } else {
          setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
          setPermissionList([])
        }
      })
      .catch(error => {

      })
  }

  const handleSortColumn = (option) => {
    setSortingOptions(option)
    const columnName = option.column;
    setColumnId(columnName)
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder)
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder)
  }

  const handleSearchFilter = (value, pageSize) => {
    const newValue = value !== undefined ? value : "";
    setSearchValue(newValue)
    handlePageChange(1, pageSize, newValue);
  }
  const handleClearSearch = () => {
    setSearchValue("")
    handlePageChange(1, pageSize, "", "id", "desc")
  }

  const handleCustomerClicks = () => {
    navigate(`/${roleName}/permission/add`)
  };
  const buttonSection = (
    <div className="text-sm-end">
        <Button
          type="button"
          color="success"
          className="btn-rounded mb-2 me-2"
          onClick={handleCustomerClicks}
        >
          <i className="mdi mdi-plus me-1" />
          {'New Permission'}
        </Button>
    </div>);





  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="ALL PERMISSIONS" />
        <Row className="vertical-scroll">
          <Col xs="12">
            <Card>
              <CardBody>
                <TableContainerV1
                  columns={columns}
                  data={permissionList}
                  pagination={pagination}
                  handlePageChange={handlePageChange}
                  handleSearchFilter={handleSearchFilter}
                  customSection={buttonSection}
                  sortOptions={sortingOptions}
                  handleSortColumn={handleSortColumn}
                  handleClearSearch={handleClearSearch}
                  className="custom-header-css"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Permission;